import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Route, Routes} from 'react-router-dom';

import HomePage from "./pages/HomePage";
import AuthenticationPage from "./pages/AuthenticationPage";
import TutorSearchPage from "./pages/TutorSearchPage";
import Login from "./components/Login";
import Register from "./components/Register";
import React from "react";
import LandingBody from "./components/LandingBody";

function App() {
    return (
        <div>
            <Routes>
                <Route path='/' element={<HomePage />} >
                    <Route index element={<LandingBody/>} />
                    <Route path='tutors' element={<TutorSearchPage />} />
                </Route>
                <Route path='/auth' element={<AuthenticationPage/>}>
                    <Route index element={<Login />} />
                    <Route path='register' element={<Register />} />
                </Route>
            </Routes>

        </div>
    );
}

export default App;
